<template>
  <div
    style="display:flex; align-items:center">
    <div
      style="display:inline-block;width:30%;font-size:80%; line-height:37px">
      <v-app>
        <v-autocomplete
          :items="options"
          item-text="dial_code"
          item-value="dial_code"
          v-model="prefix"
          label="Předvolba"
          :disabled="!editable">
          <template v-slot:item="data">
            {{ `${data.item.dial_code} - ${data.item.name}` }}
          </template>
        </v-autocomplete>
      </v-app>
    </div>
    <div style="display:inline-block;width:70%">
      <b-form-input
        class="myInput"
        :disabled="!editable"
        v-model="number" />
    </div>
  </div>
</template>
<script>
import phoneDialsCS from '@resources/phoneDialsCS';

export default {
  name: 'PhoneNumberInput',
  props: {
    value: {
      type: Object,
      required: true
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      options: phoneDialsCS
    };
  },
  computed: {
    prefix: {
      get() {
        return phoneDialsCS.filter((x) => x.dial_code.includes(this.value.prefix))[0];
      },
      set(val) {
        if (val && val.dial_code) {
          this.$emit('input', { prefix: val.dial_code, number: this.number });
        } else {
          this.$emit('input', { prefix: val, number: this.number });
        }
      }
    },
    number: {
      get() {
        return this.value.number;
      },
      set(val) {
        this.$emit('input', { prefix: this.prefix.dial_code, number: val });
      }
    }
  },
  methods: {
    updateItems(search) {
      this.options = phoneDialsCS.filter((x) => x.dial_code.includes(search) || x.name.includes(search));
    },
    getLabel(item) {
      if (item) {
        return item.dial_code;
      }

      return '';
    }
  }
};
</script>
<style lang="scss" scoped>

</style>
